import yup from "./yup-extended";

export const GetStarted_RelationshipSchema = yup
  .object()
  .shape({
    relationship: yup.object().shape({
      first_name: yup.string().required("Required"),
      state: yup.string().required("Required"),
      divided_assets: yup.string().required("Required"),
      reached_agreement: yup.string().required("Required"),
      relationship: yup.string().required("Required"),
      defacto_live_2y: yup.string().when("relationship", {
        is: "de-facto",
        then: () => yup.string().required("Required"),
        otherwise: () => yup.string().nullable()
      }),
      separated_2y: yup.string().when("relationship", {
        is: "de-facto",
        then: () => yup.string().required("Required"),
        otherwise: () => yup.string().nullable()
      }),
      divorced: yup.string().when("relationship", {
        is: "married",
        then: () => yup.string().required("Required"),
        otherwise: () => yup.string().nullable()
      }),
      divorced_1y: yup.string().when(["relationship", "divorced"], {
        is: (relationship: string, divorced: string) => relationship === "married" && divorced === "yes",
        then: () => yup.string().required("Required"),
        otherwise: () => yup.string().nullable()
      }),
      bfa_exists: yup.string().required("Required")
    })
  })
  .required();

export const GetStarted_AssetSchema = yup
  .object()
  .shape({
    finance: yup.object().shape({
      real_estate: yup.string().required("Required"),
      super_split: yup.string().required("Required"),
      overseas_assets: yup.string().required("Required"),
      business: yup.string().required("Required"),
      business_trust: yup.string().when("business", {
        is: "yes",
        then: () => yup.string().required("Required"),
        otherwise: () => yup.string().nullable()
      }),
      other_trust: yup.string().required("Required"),
      property_consent_lodged: yup.string().required("Required"),
      joint_assets_1_5m_exceed: yup.string().required("Required"),
      real_estate_num: yup.number().when("real_estate", {
        is: "yes",
        then: () => yup.number().min(1, "Must be at least 1").required("Required"),
        otherwise: () => yup.number().nullable()
      }),
      super_split_num: yup.number().when("super_split", {
        is: "yes",
        then: () => yup.number().min(1, "Must be at least 1").required("Required"),
        otherwise: () => yup.number().nullable()
      }),
      business_nt_num: yup.number().when("business", {
        is: "yes",
        then: () => yup.number().min(1, "Must be at least 1").required("Required"),
        otherwise: () => yup.number().nullable()
      }),
      business_trust_num: yup.number().when(["business", "business_trust"], {
        is: "yes",
        then: () => yup.number().min(1, "Must be at least 1").required("Required"),
        otherwise: () => yup.number().nullable()
      }),
      trust_num: yup.number().when("other_trust", {
        is: "yes",
        then: () => yup.number().min(1, "Must be at least 1").required("Required"),
        otherwise: () => yup.number().nullable()
      })
    })
  })
  .required();

export const GetStarted_SummaryServiceSchema = GetStarted_AssetSchema.shape({
  package: yup.string(),
  legal_fees: yup.number()
});
